import {
  useQuery,
  UseQueryResult,
  keepPreviousData,
} from "@tanstack/react-query";
import { fetchArticles, fetchArticle } from "data/queries";
import type {
  StrapiArticlesResponse,
  StrapiSingleArticleResponse,
} from "./types";

export const useFetchArticles = (
  page: number = 1,
  pageSize: number = 25,
): UseQueryResult<StrapiArticlesResponse> => {
  return useQuery({
    queryKey: ["articles", page, pageSize],
    queryFn: () => fetchArticles(page, pageSize),
    placeholderData: keepPreviousData,
    staleTime: 5 * 60 * 1000,
  });
};

export const useFetchArticle = (
  identifier: string,
): UseQueryResult<StrapiSingleArticleResponse> => {
  return useQuery({
    queryKey: ["article", identifier],
    queryFn: () => fetchArticle(identifier),
    enabled: !!identifier,
    staleTime: 5 * 60 * 1000,
  });
};
